<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_bill_retrospect">
                <img src="@/assets/icon-restaurant-close-restaurant.png">
            </div>
            <h2 class="title_bill_retrospect">รายการปิดร้านย้อนหลัง</h2>
        </div>

        <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div>


    <v-card>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div class="pa-4">
                <div class="d-flex justify-space-between align-center">
                    <div class="startdate_sale_statistic mr-1">
                    <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('start_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_start_date = false">
                            ยกเลิก
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                    </div>

                    <div class="enddate_sale_statistic ml-1">
                    <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('end_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_end_date = false">
                            ยกเลิก
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                    </div>
                </div>
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportPDFCloseStore">
                    ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportExcelCloseStore">
                    ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>
            </div>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <div>
                <v-data-table :headers="headers" :items="data" :search="search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.created_at}}</td>
                            <td>{{dataDetail.item.restaurant_close_time}}</td>
                            <td>{{dataDetail.item.price_total}}</td>
                            <td>{{dataDetail.item.price_delivery_total}}</td>
                            <td :class="dataDetail.item.status == 'ปิดร้านด้วยตนเอง' ? 'success--text' : dataDetail.item.status == 'ปิดร้านอัตโนมัติ' ? 'warning--text' : ''">{{dataDetail.item.status}}</td>
                            <td>
                                <span class="detail_bill_retrospect" @click="detailCloseRetrospect(dataDetail.item.id)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            
        </div>
    </v-card>
    
    <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
export default {
    name: 'closeRetrospectall',
    components: {
        NotFoundDialog,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'date',
                    value: 'created_at',
                },
                {
                    text: 'เวลาปิดร้าน',
                    value: 'restaurant_close_time'
                },
                {
                    text: 'ยอดขายหน้าร้าน',
                    value: 'price_total'
                },
                {
                    text: 'ยอดขายเดลิเวอร์รี่',
                    value: 'price_delivery_total'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'ดูรายละเอียด',
                    value: 'action'
                },
            ],
            data: [],
            menu_start_date: false,
            menu_end_date: false,
            start_date_be: '',
            start_date: '',
            end_date_be: '',
            end_date: '',
            source_store_select:0,
            type_product_select:0,
            source_store_list:[{
                source_name:'ทั้งหมด',
                id:0
            }],
            type_product_list:[{
                name:'ทั้งหมด',
                id:0
            }],
            dialogVisible:false
        }
    },
    methods: {
        async closeRetrospectList() {
            this.loading_page = true
            this.data = []
            HTTP.post('/listCloseStore', {date_start:this.start_date,date_end:this.end_date}, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        response.data.list.forEach(detail => {
                            let status = null
                            if (detail.status == 0) {
                                status = 'ปิดร้านด้วยตนเอง'
                            }
                            if (detail.status == 1) {
                                status = 'ปิดร้านอัตโนมัติ'
                            }
                            if (detail.status == null) {
                                status = '-'
                            }
                            this.data.push({
                                id:detail.id,
                                created_at:detail.created_at,
                                restaurant_close_time:detail.restaurant_close_time,
                                price_total:detail.price_total,
                                price_delivery_total:detail.price_delivery_total,
                                status:status,
                            })
                        })
                        this.loading_page = false
                        if(response.data.list == ''){
                            this.dialogVisible = true;
                        }
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailCloseRetrospect(id){
            const idPage = {
                id:id
            }
            this.$store.commit('detailCloseRetrospectPage',idPage)
            this.$router.push('/closeretrospectdetail')
        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
            this.closeRetrospectList()
        },
        dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                this.start_date_be = ''
                }
                if (this.start_date) {
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                this.end_date_be = ''
                }
                if (this.end_date) {
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async exportExcelCloseStore() {
            HTTP.post('/export-close-store-excel', {date_start:this.start_date,date_end:this.end_date},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.setAttribute('download', 'close_store.xlsx');
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        async exportPDFCloseStore() {
            HTTP.post('/export-close-store-pdf', {date_start:this.start_date,date_end:this.end_date},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.setAttribute('download', 'close_store.pdf');
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        clearSearch(is_retry){            
            if(is_retry){
                this.dialogVisible = false
                this.start_date = ''
                this.end_date = ''
                this.closeRetrospectList()
            }
        }
    },

    mounted(){
        this.closeRetrospectList()
    }

}
</script>
